export const GET_IP_LOADING = 'REDUX_SAGA_GET_IP_LOADING';
export const GET_IP_SUCCESS = 'REDUX_SAGA_GET_IP_SUCCESS';
export const GET_IP_ERROR = 'REDUX_SAGA_GET_IP_ERROR';

export const actionGetIP = (dispatch) => {
    dispatch({ type: GET_IP_LOADING })
};